export default {
  input: 'w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px]',
  inputsWrapper: 'flex flex-col gap-[24px]',
  inputInfo: 'w-[calc(100vw-40px)] md:w-[350px] lg:w-[409px] max-w-[409px] text-[14px] text-color-text-grey mt-[4px]',
  errorText: 'text-center text-color-red font-inter font-[14px] mt-[8px]',
  modalButton: 'mt-[24px]',
  backLink: 'flex items-center cursor-pointer mb-[16px] max-w-fit',
  backLinkText: 'ml-[4px]',
};
